import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { t } from '../i18n.js';
import { ICOON } from './iconen.jsx';
import SocMenu from './SocMenu.jsx';

/* De knoppen in het menu, als data met `titel`/`uitleg`: zo ziet scripts/controleer-vertalingen.js de teksten. */
const KNOPPEN = [
  { icoon: 'schuif', titel: 'Instellingen', uitleg: 'Thema en taal, alleen voor jou', pad: '/instellingen' },
  { icoon: 'tandwiel', titel: 'Beheer', uitleg: 'Wie mag wat in ADTS ZERO, voor iedereen', pad: '/beheer', recht: 'rechten.beheren' },
  { icoon: 'boek', titel: 'Uitleg', uitleg: 'Hoe ADTS ZERO werkt, per onderdeel', pad: '/uitleg' },
  { icoon: 'ster', titel: 'Wat er nieuw is', uitleg: 'De laatste wijzigingen in ADTS ZERO', pad: '/nieuw' },
  { icoon: 'slot', titel: 'Wachtwoord wijzigen', uitleg: 'De noodingang, niet je ADTS-account', pad: '/wachtwoord', nood: true },
];

/**
 * Het menu achter je naam, rechtsboven, **zoals in ADTS-ONE** (Gebruikersmenu.jsx daar): wie je bent, dan
 * omkaderde knoppen met een icoon en een regel uitleg (Instellingen, Beheer, Uitleg, Wat er nieuw is,
 * Wachtwoord), en onderaan Afmelden.
 *
 * **Instellen doe je hier niet.** Thema en taal staan onder Instellingen en nergens anders; dit menu is de
 * weg ernaartoe. Wat ZERO extra heeft en ONE niet, staat bovenaan: de klant die je bekijkt en de
 * SOC-schermen — die horen bij het kijken, niet bij je voorkeuren, en hebben geen andere plek.
 */
export default function Gebruikersmenu({ mij, onAfmelden, klant = null }) {
  const [open, zetOpen] = useState(false);
  const doos = useRef(null);
  const naar = useNavigate();

  useEffect(() => {
    if (!open) return undefined;
    const buiten = (e) => { if (!doos.current?.contains(e.target)) zetOpen(false); };
    const toets = (e) => { if (e.key === 'Escape') zetOpen(false); };
    document.addEventListener('mousedown', buiten);
    document.addEventListener('keydown', toets);
    return () => { document.removeEventListener('mousedown', buiten); document.removeEventListener('keydown', toets); };
  }, [open]);

  const naam = mij.name || mij.number;
  const rollen = mij.roleLabels.map((r) => t(r)).join(', ');
  const initialen = naam.split(' ').filter(Boolean).map((w) => w[0]).join('').slice(-2).toUpperCase();
  const ga = (pad) => { zetOpen(false); naar(pad); };
  const gekozen = klant?.lijst.find((k) => String(k.id) === String(klant.gekozen));
  const knoppen = KNOPPEN.filter((x) => (!x.recht || mij.permissions.includes(x.recht)) && (!x.nood || mij.via === 'noodingang'));

  return (
    <div className="user-menu" ref={doos}>
      {/* Zoals in ADTS-ONE: initialen in een rondje, met je naam en rol ernaast; het menu klapt eronder open. */}
      <button type="button" className="whobtn" aria-expanded={open} aria-haspopup="true" onClick={() => zetOpen((v) => !v)}>
        <span className="avatar" aria-hidden="true">{initialen}</span>
        <span className="whotext">
          <span className="n">{naam}</span>
          {rollen && <span className="r">{rollen}</span>}
        </span>
      </button>
      {open && (
        <div className="ikpop" role="menu">
          <div className="ikkop">
            <span className="avatar groot" aria-hidden="true">{initialen}</span>
            <span>
              <span className="ikname">{naam}</span>
              {(rollen || mij.email) && <span className="ikmeta">{[rollen, mij.email].filter(Boolean).join(' · ')}</span>}
              <span className="ikmeta num">{mij.number}</span>
            </span>
          </div>

          {/* ZERO-specifiek: welke klant je bekijkt en de SOC-schermen (docs/besluiten/klant-kiezen-en-alle-klanten.md). */}
          {((klant && klant.lijst.length > 0) || klant?.soc) && <hr className="popstreep" />}
          {klant && klant.lijst.length > 0 && (
            <div className="ikveld">
              <label className="label" htmlFor="menu-klant">{t('Klant')}</label>
              <select id="menu-klant" className="menu-select" value={klant.gekozen} onChange={(e) => klant.zet(e.target.value)}>
                <option value="alle">{t('Alle klanten ({n})', { n: klant.lijst.length })}</option>
                {klant.lijst.map((x) => <option key={x.id} value={x.id}>{x.name}{x.own ? ` ${t('(eigen)')}` : ''}</option>)}
              </select>
            </div>
          )}
          {klant?.soc && <SocMenu klant={klant.gekozen} klantCode={gekozen?.code} klantNaam={gekozen?.name} klaar={() => zetOpen(false)} />}

          <hr className="popstreep" />
          <div className="menuknoppen">
            {knoppen.map((x) => (
              <button key={x.pad} type="button" onClick={() => ga(x.pad)}>
                {ICOON[x.icoon]}<span><b>{t(x.titel)}</b><br /><span className="s">{t(x.uitleg)}</span></span>
              </button>
            ))}
          </div>

          <hr className="popstreep" />
          <button type="button" className="btn afmeldknop" onClick={() => { zetOpen(false); onAfmelden(); }}>{t('Afmelden')}</button>
        </div>
      )}
    </div>
  );
}
